import * as types from './actionTypes';

export function filterSet(filter: any) {
  return { type: types.FILTER_SET, filter };
}
